// extracted by mini-css-extract-plugin
export default {"body":"InstructorProfile_body__+WZcT","stats":"InstructorProfile_stats__+cYge","optsCont":"InstructorProfile_optsCont__eYWmI","danger":"InstructorProfile_danger__pPVJs"};